import { Flame } from 'lucide-react';

/**
 * The EAX FUEL mark: the flame tile, the wordmark and the tagline.
 *
 * The tile's maize underline and the flame colour come from tokens via CSS, so
 * both flip correctly in dark mode. In the old app the flame colour was read
 * from a mutable JavaScript palette during render.
 *
 * The tagline is two-tone, with "in balance" carrying the accent. Both halves are
 * measured against the page background in the token tests, so neither can drift
 * below AA the way the previous palette's accent text did.
 */
export function BrandMark() {
  return (
    <div className="app-header__brand">
      <div className="brand-mark" aria-hidden="true">
        <Flame size={22} color="var(--color-brand)" />
      </div>
      <div>
        <p className="disp brand-wordmark">EAX FUEL</p>
        <p className="brand-tagline">
          your day, <span className="brand-tagline__accent">in balance</span>
        </p>
      </div>
    </div>
  );
}
